import type { TagProps } from '@lemonade-hq/uniclient-theme';
import type { InterpolableTextProps } from './interpolable_text';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export interface GridProps<TSubtitleText extends string = string> extends UniclientBaseComponentProps {
  readonly variant?: 'lg' | 'sm';
  readonly items: GridItemProps<TSubtitleText>[];
  readonly itemsPerRow?: 2 | 3;
}

interface Tag {
  readonly content: string;
  readonly variant?: TagProps['variant'];
}

export interface ThumbnailImage {
  readonly sm: string;
  readonly lg: string;
}

export interface GridItemProps<TSubtitleText extends string = string> {
  readonly thumbnail:
    | ThumbnailImage
    | string
    | {
        readonly url: ThumbnailImage | string;
        readonly tooltip: string;
      };
  readonly title: string;
  readonly subtitle?: InterpolableTextProps<TSubtitleText>;
  readonly tag?: Tag;
}

export type UniclientGridProps<TSubtitleText extends string = string> = GridProps<TSubtitleText> &
  UniclientWizardComponentBase<'grid'>;

export function grid<const TSubtitle extends string>(props: GridProps<TSubtitle>): UniclientGridProps<TSubtitle> {
  return { ...props, type: 'grid' };
}

export function gridItem<const TSubtitle extends string, TItem extends GridItemProps<TSubtitle>>(props: TItem): TItem {
  return props;
}
